import routineStages from './routineStages';
import createRoutineCreator from './createRoutineCreator';
var createRoutine = createRoutineCreator(routineStages);
export default createRoutine;


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-saga-routines/es/createRoutine.js
// module id = 1567
// module chunks = 0